import request from "../utils/request"

export function getPicByType(params) {
	return request({
	     url: '/pic/detail',
	     method: 'get',
	     params
	})
}

export function getPicList(params) {
	return request({
	     url: '/pic/list',
	     method: 'get',
	     params
	})
}
